import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CustomStyles from './CustomStyles';
import ClientProvider from './client';
export default createDemo(import.meta.url, CustomStyles, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/theming/demos/custom-styles/CustomStyles.tsx",
    "fileName": "CustomStyles.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Checkbox from '@mui/material/Checkbox';\nimport { createTheme, ThemeProvider, styled } from '@mui/material/styles';\nimport { orange } from '@mui/material/colors';\n\ndeclare module '@mui/material/styles' {\n  interface Theme {\n    status: {\n      danger: string;\n    };\n  }\n  // allow configuration using `createTheme()`\n  interface ThemeOptions {\n    status?: {\n      danger?: string;\n    };\n  }\n}\n\nconst CustomCheckbox = styled(Checkbox)(({ theme }) => ({\n  color: theme.status.danger,\n  '&.Mui-checked': {\n    color: theme.status.danger,\n  },\n}));\n\nconst theme = createTheme({\n  status: {\n    danger: orange[500],\n  },\n});\n\nexport default function CustomStyles() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <CustomCheckbox defaultChecked />\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 38,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Checkbox from '@mui/material/Checkbox';\nimport { createTheme, ThemeProvider, styled } from '@mui/material/styles';\nimport { orange } from '@mui/material/colors';\n\ndeclare module '@mui/material/styles' {\n  interface Theme {\n    status: {\n      danger: string;\n    };\n  }\n  // allow configuration using `createTheme()`\n  interface ThemeOptions {\n    status?: {\n      danger?: string;\n    };\n  }\n}\n\nconst CustomCheckbox = styled(Checkbox)(({ theme }) => ({\n  color: theme.status.danger,\n  '&.Mui-checked': {\n    color: theme.status.danger,\n  },\n}));\n\nconst theme = createTheme({\n  status: {\n    danger: orange[500],\n  },\n});\n\nexport default function CustomStyles() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider theme={theme}>\n      <CustomCheckbox defaultChecked />\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 34
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "theme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "CustomCheckbox"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultChecked"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 36
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 38,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/material/Checkbox",
      "@mui/material/styles",
      "@mui/material/colors"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
